import { userApi } from '..'

export const updateLanguage = async (language: string) => {
  return userApi.post('current/lang', {
    language
  })
}
